import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { useToast } from "vue-toastification";
const toast = useToast();
interface ILoadingOptions {
    showAllBars?: boolean; // si se muestran success/failed/error
    bulk?: boolean;        // si es proceso masivo
    process?: number;      // progreso inicial
}

export default function messages() {

    const notification = (type:string, messages: any) => {
        switch ( type ) {
            case 'success':
                    toast.success(messages);        
                break;
            case 'info':
                    toast.info(messages);
                break;
            case 'warning':
                toast.warning(messages);
                break;
            case 'error':
                toast.error(messages);
                break;
            default: 
            toast(messages);
                break;
        }
    }
    
    function detailNotification(icons: any, title: any, dto: any, startparameter: number) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            i++;
            if (i > startparameter) {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
        }
        valueDto += '</ul>';

        Swal.fire({ title: title, html: valueDto, icon: icons })
    }

    function sendParameters(icons: any, title: any, dto: any, startparameter: number, show: string) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            if (startparameter == 1) {
                if (show.includes(i.toString())) { valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>'; }
            } else {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
            i++;
        }
        valueDto += '</ul>';

        return Swal.fire({
            title: title,
            html: valueDto,
            icon: icons,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Accept",
            focusCancel: true,
            preConfirm: (isConfirm) => {
                return isConfirm;
            }
        }).then(response => {
            Swal.close();
            return response.value;
        });

    }

    function sendThreeButtons(icons: any, title: any, dto: any, startparameter: number, show: string, buttonThree: string) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            if (startparameter == 1) {
                if (show.includes(i.toString())) { valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>'; }
            } else {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
            i++;
        }
        valueDto += '</ul>';

        return Swal.fire({
            title: title,
            html: valueDto,
            icon: icons,
            confirmButtonColor: "#1f7e49",
            confirmButtonText: buttonThree,
            denyButtonColor: "#3085d6",
            showDenyButton: true,
            denyButtonText: 'Accept',
            focusCancel: true,
            showCancelButton: true,
            cancelButtonColor: "#b82222",
            preConfirm: (isConfirm) => {
                return isConfirm;
            },
        }).then(response => {
            Swal.close();
            return response;
        });

    }

    const validateNotification = (dto: any) => {
        toast.info(dto.required);
    };

    const alertAutorizationModule = (module: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: "Module " + module,
            text: message,
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

    const alertAutorizationAction = (acction: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: "Action " + acction,
            text: message,
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

    const alertAutorization = (title: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: message,
            //text: title,         
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

   const loading = (
        message: string | null,
        options?: {
            showAllBars: boolean;
            bulk: boolean;
            process: number;
            success?: number;
            failed?: number;
            error?: number;
            total?: number; 
        }
    ) => {
        const showAllBars = options?.showAllBars ?? true;
        const isBulk = options?.bulk ?? false;
        const process = options?.process ?? 0;
        const success = options?.success ?? 0;
        const failed = options?.failed ?? 0;
        const error = options?.error ?? 0;
        const total = options?.total ?? 0;

        const processP = total > 0 ? Math.floor((process / total) * 100) : 0;
        const successP = total > 0 ? Math.floor((success / total) * 100) : 0;
        const failedP = total > 0 ? Math.floor((failed / total) * 100) : 0;
        const errorP = total > 0 ? Math.floor((error / total) * 100) : 0;

        const htmlBars = isBulk
            ? `
            <div class="progress-bars-container">

                <div class="progress-section">
                    <div class="progress-header">
                        <span class="progress-label">Processing</span>
                        <span class="progress-count" id="count-process">${process}/${total}</span>
                        <span class="progress-percent" id="percent-process">${processP}%</span>
                    </div>
                    <div class="progress-container">
                        <div id="bar-process" class="progress-bar main-bar"
                            style="width:${processP}%"></div>
                    </div>
                </div>

                ${
                    showAllBars
                        ? `
                        <!-- Barras Detalladas -->
                        <div class="detailed-bars">
                            <div class="progress-item">
                                <div class="progress-info">
                                    <span class="status-indicator success-dot"></span>
                                    <span class="progress-label">Success</span>
                                    <span class="progress-count" id="count-success">${success}/${total}</span>
                                    <span class="progress-percent" id="percent-success">${successP}%</span>
                                </div>
                                <div class="progress-container">
                                    <div id="bar-success" class="progress-bar success-bar"
                                        style="width:${successP}%"></div>
                                </div>
                            </div>

                            <div class="progress-item">
                                <div class="progress-info">
                                    <span class="status-indicator warning-dot"></span>
                                    <span class="progress-label">Failed</span>
                                    <span class="progress-count" id="count-failed">${failed}/${total}</span>
                                    <span class="progress-percent" id="percent-failed">${failedP}%</span>
                                </div>
                                <div class="progress-container">
                                    <div id="bar-failed" class="progress-bar warning-bar"
                                        style="width:${failedP}%"></div>
                                </div>
                            </div>

                            <div class="progress-item">
                                <div class="progress-info">
                                    <span class="status-indicator error-dot"></span>
                                    <span class="progress-label">Errors</span>
                                    <span class="progress-count" id="count-error">${error}/${total}</span>
                                    <span class="progress-percent" id="percent-error">${errorP}%</span>
                                </div>
                                <div class="progress-container">
                                    <div id="bar-error" class="progress-bar error-bar"
                                        style="width:${errorP}%"></div>
                                </div>
                            </div>
                        </div>

                        <div class="stats-summary">
                            <div class="stat-item">
                                <span class="stat-number" id="stat-total">${total}</span>
                                <span class="stat-label">Total</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number success-text" id="stat-success">${success}</span>
                                <span class="stat-label">Success</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number warning-text" id="stat-failed">${failed}</span>
                                <span class="stat-label">Failed</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number error-text" id="stat-errors">${error}</span>
                                <span class="stat-label">Errors</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number" id="stat-processing">${process}</span>
                                <span class="stat-label">Processing</span>
                            </div>
                        </div>
                        `
                        : ""
                }
            </div>
            `
            : "";

        Swal.fire({
            title: message ?? "Processing, please wait...",
            html: htmlBars,
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            backdrop: 'rgba(0,0,0,0.4)',
            width: '600px',
            padding: '20px',
            didOpen: () => {
                Swal.showLoading();
            }
        });
    };
    
   
    const updateLoading = (
        showAllBars: boolean,
        current: number,
        total: number,
        success: number = 0,
        failed: number = 0,
        errors: number = 0
    ) => {
        const processP = total > 0 ? Math.floor((current / total) * 100) : 0;
        const successP = total > 0 ? Math.floor((success / total) * 100) : 0;
        const failedP = total > 0 ? Math.floor((failed / total) * 100) : 0;
        const errorP = total > 0 ? Math.floor((errors / total) * 100) : 0;

        const safeUpdate = () => {
            
            const updateElement = (id: string, value: string) => {
                const element = document.getElementById(id);
                if (element && element.isConnected) {
                    element.textContent = value;
                }
            };

            const updateBar = (id: string, width: number) => {
                const element = document.getElementById(id) as HTMLElement;
                if (element && element.isConnected) {
                    element.style.width = `${width}%`;
                }
            };

            updateElement("count-process", `${current}/${total}`);
            updateElement("percent-process", `${processP}%`);
            updateBar("bar-process", processP);

            if (showAllBars) {
                updateElement("count-success", `${success}/${total}`);
                updateElement("percent-success", `${successP}%`);
                updateBar("bar-success", successP);
                
                updateElement("count-failed", `${failed}/${total}`);
                updateElement("percent-failed", `${failedP}%`);
                updateBar("bar-failed", failedP);
                
                updateElement("count-error", `${errors}/${total}`);
                updateElement("percent-error", `${errorP}%`);
                updateBar("bar-error", errorP);

                updateElement("stat-total", `${total}`);
                updateElement("stat-success", `${success}`);
                updateElement("stat-failed", `${failed}`);
                updateElement("stat-errors", `${errors}`);
                updateElement("stat-processing", `${current}`);
            }
        };

        setTimeout(safeUpdate, 0);
    };

    const finishLoading = (current: number, total: number) => {
        const container = document.getElementById("progress-container");
        const html = container ? container.outerHTML : "";
        Swal.hideLoading();
        Swal.update({
            title: `Completed ${current} / ${total}`,
            html,
            showConfirmButton: true,
            confirmButtonText: "OK",
            allowEscapeKey: true,
            allowOutsideClick: true
        });
    };    

    const closeLoading = () => {
        Swal.close();
    }

    const logOut = (msj: string, total: number) => {
        let messages = '';
        if (total > 0) {
            messages = `<div class="logout-swal-content"><div class="logout-swal-icon"></div><div>${total}, ${msj} Wish To Continue</div></div>`;
        } else {
            messages = `<div class="logout-swal-content"><div class="logout-swal-icon"></div><div> Are you sure to log out</div></div>`;
        }

        return Swal.fire({
            title: '<span class="logout-swal-title">Log Out</span>',
            html: messages,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Accept",
            focusCancel: true,
            
            backdrop: 'rgba(10,43,60,0.5)',
            customClass: {
                confirmButton: 'logout-confirm-button',
                cancelButton: 'logout-cancel-button'
            },
            preConfirm: (isConfirm) => {
                return isConfirm;
            }
        }).then(response => {
            Swal.close();
            return response.value;
        });

    }
     
    const accessNotification = async (icons: any, title: String)=> {
    return Swal.fire({
            title: title,        
            icon: icons,
            footer: '<a href="#">consult with goconnexus support</a>',
            backdrop: 'rgba(10,43,60,0.8)',
            allowOutsideClick: false,           
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Accept",
            focusCancel: true,
            preConfirm: (isConfirm) => {
                return isConfirm;
            }
        }).then(response => {
            Swal.close();
            return response.value;
        });
        
};

    return {
        notification, detailNotification, sendParameters, validateNotification,
        alertAutorizationModule, alertAutorizationAction, alertAutorization,
        loading, updateLoading, closeLoading,finishLoading,
        sendThreeButtons, logOut, accessNotification
    }
}